import Typed from 'typed.js'

$(function(){
    const $typed = $('#typed')
    if ($typed.length) {
        (new Typed($typed.get(0), {
            loop:true,
            backDelay: 1200,
            typeSpeed: 20,
            backSpeed: 10,
            stringsElement: '#typed-strings'
        }))
    }
})
